/**
 * MODULE: _shared/frontend-shell/src/features/crm/hooks/useCrmProductCatalog.ts
 * PURPOSE: Tenant product catalog for entitlement assignment (reads sales-profile API)
 * PUBLIC_API: useCrmProductCatalog
 */

import { useQuery } from '@tanstack/react-query';
import { useProducts } from '@domain/sales-profile';

export function useCrmProductCatalog(enabled = true) {
  const { products, isLoading, error, refetch } = useProducts(false);
  return {
    products: enabled ? products : [],
    loading: enabled ? isLoading : false,
    error: enabled ? error : null,
    refetch,
  };
}
